import { useAtomValue } from 'jotai';
import { uiContextAtomDisplayMode } from '@rocco/states/uiContextAtomDisplayMode';
import type {
    PageBuilderModuleMetaProps,
    TextColumnProps,
} from '@modules/page-builder/types';
import SingleParagraphModule from '../single-paragraph-module/SingleParagraphModule';

interface DuoParagraphModuleProps extends PageBuilderModuleMetaProps {
    columns: TextColumnProps[];
    /** Project detail revamp - sets both columns in the page's own body prose. */
    isProjectRevamp?: boolean;
}

/**
 * A rendered Page Builder module for a duo paragraph.
 *
 * The editor version is at
 * {@link packages/web/app/modules/page-builder/component/edit/duo-paragraph-module/DuoParagraphModule.tsx}
 */
const DuoParagraphModule = ({
    columns,
    meta,
    isProjectRevamp,
}: DuoParagraphModuleProps) => {
    const { isMobile } = useAtomValue(uiContextAtomDisplayMode);
    const [firstColumn, secondColumn] = columns;

    if (!firstColumn || !secondColumn) {
        return null;
    }

    return (
        <div className="mx-auto grid w-full grid-cols-1 gap-x-6 gap-y-7 md:max-w-225 md:grid-cols-2">
            {(firstColumn.content || !isMobile) && (
                <SingleParagraphModule
                    column={firstColumn}
                    meta={meta}
                    isProjectRevamp={isProjectRevamp}
                />
            )}
            {(secondColumn.content || !isMobile) && (
                <SingleParagraphModule
                    column={secondColumn}
                    meta={meta}
                    isProjectRevamp={isProjectRevamp}
                />
            )}
        </div>
    );
};

export default DuoParagraphModule;
